import React, { useEffect } from 'react'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import './styles.scss'
import {
  MAPBOX_SETTINGS,
  CANTONSNODATA,
  LAYERSPERCANTON
} from '../../images/settings.js'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { InterfaceMapBox } from 'types/IMapBox'

interface InterfaceMapBoxComponent {
  registerMap: Function
  locales: {
    water: string
    ava: string
    finger: string
    [key: string]: string
  }
}

var map: InterfaceMapBox

export const MapBox = ({ registerMap, locales }: InterfaceMapBoxComponent) => {
  // Create Map and Register for other Components
  useEffect(() => {
    mapboxgl.accessToken = MAPBOX_SETTINGS.token
    map = new mapboxgl.Map(
      {
        container: 'map',
        center: MAPBOX_SETTINGS.center,
        style: MAPBOX_SETTINGS.style,
        maxBounds: MAPBOX_SETTINGS.bounds,
        attributionControl: false,
        zoom: 7.49
      },
      []
    )
    map.deactivateInteraction = () => {
      map.scrollZoom.disable()
      map.boxZoom.disable()
      map.dragRotate.disable()
      map.dragPan.disable()
      map.keyboard.disable()
      map.doubleClickZoom.disable()
      map.touchZoomRotate.disable()
    }
    map.activateInteraction = () => {
      map.scrollZoom.enable()
      map.boxZoom.enable()
      map.dragPan.enable()
      map.keyboard.enable()
      map.doubleClickZoom.enable()
      map.touchZoomRotate.enable()
      map.touchZoomRotate.disableRotation()
    }
    if (!browserCheck.isDesktop) {
      map.setMaxBounds(MAPBOX_SETTINGS.boundsMobile)
      map.setZoom(6.25)
    } else {
      map.setZoom(7.49)
    }

    registerMap(map)
    map.once('style.load', () => {
      // Marker
      var el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage = 'url("images/marker.svg")'
      map.marker = new mapboxgl.Marker(el).setLngLat([0, 0]).addTo(map)

      // Filter Cantons with no data
      var filterOverlay: [string | string[]] = ['any']
      CANTONSNODATA.forEach(canton => {
        filterOverlay.push(['==', 'name', canton])
        LAYERSPERCANTON.forEach(haz => {
          map.setLayoutProperty(canton + haz, 'visibility', 'none')
        })
      })
      map.setFilter('canton', filterOverlay)
    })
    map.on('error', () => {
      /* prevent missign tile error (partially) */
    })

    map.addControl(
      new mapboxgl.AttributionControl({
        customAttribution: locales.attribution
      }),
      'bottom-right'
    )
    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right')
    map.deactivateInteraction()
    map.dragRotate.disable()
    map.touchZoomRotate.disableRotation()
  }, [])

  const toggleMapActivation = e => {
    e.stopPropagation()
    const button = e.target
    if (button) {
      if (button.getAttribute('off') === 'true') {
        button.setAttribute('off', 'false')
        button.children[0].src = 'images/scrolling.svg'
        button.children[1].innerHTML = locales.activation[1]
        map.activateInteraction()
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'Interactions',
          // eslint-disable-next-line @typescript-eslint/camelcase
          event_action: browserCheck.isTouch ? 'tap' : 'click',
          // eslint-disable-next-line @typescript-eslint/camelcase
          event_label: 'mapActivated'
        })
      } else {
        button.setAttribute('off', 'true')
        button.children[1].innerHTML = locales.activation[0]
        button.children[0].src = 'images/moving.svg'
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'Interactions',
          // eslint-disable-next-line @typescript-eslint/camelcase
          event_action: browserCheck.isTouch ? 'tap' : 'click',
          // eslint-disable-next-line @typescript-eslint/camelcase
          event_label: 'mapDeactivated'
        })
        map.deactivateInteraction()
      }
    }
  }
  return (
    <div id='map'>
      <div className='toggle' onClick={toggleMapActivation} off='true'>
        <img src={require('../../images/moving.svg')} width='20px' />
        <div>{locales.activation[0]}</div>
      </div>
    </div>
  )
}
